import { Config } from 'next-i18n-router/dist/types';

const i18nConfig: Config = {
  locales: ['en', 'th'],
  defaultLocale: 'th',
  localeDetector: false,
}

export default i18nConfig;